import { render, staticRenderFns } from "./exemption.vue?vue&type=template&id=b8ff6644&scoped=true&"
import script from "./exemption.vue?vue&type=script&lang=js&"
export * from "./exemption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ff6644",
  null
  
)

export default component.exports